import { Injectable, inject } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { tap } from 'rxjs';
import { isToastieAction } from '../models/toastie.model';
import { ToastService } from '../toast.service';

@Injectable()
export class ToastEffect {
  private readonly actions$ = inject(Actions);
  private readonly toastService = inject(ToastService);

  toastEffect$ = createEffect(
    () => {
      return this.actions$.pipe(
        tap((action) => {
          if (isToastieAction(action)) {
            this.toastService.showToastie(action.toast);
          }
        })
      );
    },
    { dispatch: false }
  );
}
